var SegmentLegacyModule = /** @class */ (function () {
    function SegmentLegacyModule() {
    }
    return SegmentLegacyModule;
}());
export { SegmentLegacyModule };
